module.exports = __webpack_public_path__ + "static/media/masthaven.cfd456c6.png";